import { render, staticRenderFns } from "./LegalDocumentContent_CXrafZ.vue?vue&type=template&id=40aa6850&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_CXrafZ.vue?vue&type=style&index=0&id=40aa6850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa6850",
  null
  
)

export default component.exports